import type { TOC } from '@ember/component/template-only';
import { on } from '@ember/modifier';
import { PrismButton, PrismTooltip } from '@mylighthouse/prism-ember';
import type { IconName } from '@mylighthouse/prism-ember/types/components/prism/icon';
import { optional } from '@nullvoxpopuli/ember-composable-helpers';

interface GeneralDropdownsTriggersTriggerDropdownIconButtonSignature {
  Args: {
    buttonType: string;
    class?: string;
    dataTestId?: string;
    disabledMessage?: string;
    icon?: IconName;
    iconBefore?: IconName;
    isDisabled?: boolean;
    label?: string;
    small: boolean;
    toggleDropdown?: () => void;
  };
}

const GeneralDropdownsTriggersTriggerDropdownIconButton = <template>
  <PrismButton
    {{! @glint-expect-error }}
    @buttonType={{@buttonType}}
    @icon={{@icon}}
    @iconBefore={{@iconBefore}}
    @isDisabled={{@isDisabled}}
    @label={{@label}}
    @size={{if @small "small"}}
    class={{@class}}
    data-test-id={{@dataTestId}}
    {{on "click" (optional @toggleDropdown)}}
  >
    {{#if @isDisabled}}
      {{#if @disabledMessage}}
        <PrismTooltip @text={{@disabledMessage}} />
      {{/if}}
    {{/if}}
  </PrismButton>
</template> satisfies TOC<GeneralDropdownsTriggersTriggerDropdownIconButtonSignature>;

export default GeneralDropdownsTriggersTriggerDropdownIconButton;
